



























































































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import Transaction from '@/models/Accounts/Shared/Transactions/Transaction';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import DebitCreditCode from '@/models/Shared/DebitCreditCode';

@Component({ name: 'LedgerTransactionDetailsDialog', components: { FieldLabel } })
export default class extends SaascadaVueDialog {

    dialog = false;
    DebitCreditCode = DebitCreditCode;

    @Prop({ required: true })
    transaction: Transaction;

    async releaseTransaction() {
        this.dialog = false;
        await DepositAccountModule.releasePendingTransaction(this.transaction.transactionId);
    }

    // TODO: This is a workaround until the API returns the balance in an Amount object format
    get formattedBalance() {
        return {
            amount: this.transaction.balance,
            currency: this.transaction.amount.currency
        }
    }

    // TODO: This is a workaround until the API returns the availableBalance in an Amount object format
    get formattedAvailableBalance() {
        return {
            amount: this.transaction.availableBalance,
            currency: this.transaction.amount.currency
        }
    }

}
